/* Measure visual lines without adding duplicate accessible text or a font dependency. */
window.Tc = window.Tc || {};
Tc.splitLines = (heading) => {
  if (!heading || !heading.clientWidth) return;
  const authored = heading._tcLines || [...heading.children].map((line) => line.textContent.trim());
  heading._tcLines = authored.length ? authored : [heading.textContent.trim()];
  const width = heading.clientWidth;
  const font = getComputedStyle(heading).font;
  const key = `${width}:${font}`;
  if (heading.dataset.tcLineSize === key) return;

  // A hidden copy inherits exactly the heading's typography and available width.
  const probe = heading.cloneNode(false);
  probe.removeAttribute('id');
  probe.removeAttribute('data-tc-split');
  probe.setAttribute('aria-hidden', 'true');
  probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;width:${width}px;max-width:none;height:auto;margin:0;transform:none;`;
  const groups = heading._tcLines.map((text) => {
    const line = document.createElement('span');
    line.textContent = text;
    probe.append(line);
    return line;
  });
  heading.after(probe);
  const lines = [];
  groups.forEach((group) => {
    const node = group.firstChild;
    if (!node) return;
    let top = null, line = [];
    for (const word of node.textContent.matchAll(/\S+/g)) {
      const range = document.createRange();
      range.setStart(node, word.index);
      range.setEnd(node, word.index + word[0].length);
      const y = range.getBoundingClientRect().top;
      if (top !== null && Math.abs(y - top) > 2) { lines.push(line.join(' ')); line = []; }
      top = y;
      line.push(word[0]);
    }
    if (line.length) lines.push(line.join(' '));
  });
  probe.remove();
  const fragment = document.createDocumentFragment();
  lines.forEach((text, i) => {
    const mask = document.createElement('span');
    const inner = document.createElement('span');
    inner.textContent = text;
    inner.style.setProperty('--tc-l', i);
    inner.style.setProperty('--l', i);
    mask.append(inner);
    fragment.append(mask);
    if (i < lines.length - 1) fragment.append(document.createTextNode(' '));
  });
  heading.replaceChildren(fragment);
  heading.dataset.tcLineSize = key;
};

(() => {
  const headings = () => [...document.querySelectorAll('[data-tc-split]')];
  const split = () => headings().forEach(Tc.splitLines);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', split, { once: true });
  else split();
  document.fonts?.ready.then(() => { headings().forEach((h) => { delete h.dataset.tcLineSize; }); split(); });
  let resize;
  addEventListener('resize', () => { clearTimeout(resize); resize = setTimeout(split, 120); });
  document.addEventListener('shopify:section:load', split);
})();
